<template>
        <div class="column">
            <div class="field is-horizontal">
                <div class="field-body">
                    <div class="field-label is-normal">
                        <label class="label">Condition</label>
                    </div>
                    <div class="field is-narrow">
                        <div class="control">
                            <div class="select is-fullwidth">
                                <select v-model="condition">
                                        <option disabled :value="null">Condition</option>
                                        <option value="100">100%</option>
                                        <option value="50">50%/50%</option>
                                        <option value="30">30%/70%</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="field is-narrow">
                        <div class="control">
                            <div class="select is-fullwidth">
                                <select v-model="incoterm">
                                    <option value="0">Incoterm</option>
                                    <option value="1">FOB</option>
                                    <option value="2">CIF</option>
                                    <option value="3">C&F</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="field is-narrow currency">
                        <div class="control">
                            <div class="select is-fullwidth">
                                <select v-model="currency">
                                    <option :value="null" disabled>Currency</option>
                                    <option value="1">¥ (JPY)</option>
                                    <option value="2">$ (USD)</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="field">
                        <div class="field has-addons">
                            <p class="control">
                                <a class="button is-static">
                                    <i class="fas fa-dollar-sign"></i>
                                </a>
                            </p>
                            <p class="control" style="max-width: 100px">
                                <input class="input" type="number" v-model="rate" readonly>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Remarks</label>
                </div>
                <div class="field is-expanded remarks">
                    <div class="field has-addons">
                        <p class="control">
                            <a class="button is-static">
                                <i class="fas fa-car"></i>
                            </a>
                        </p>
                        <p class="control remarks">
                            <input class="input" v-model="remarks" placeholder="Invoice remarks">
                        </p>
                    </div>
                </div>
                <div class="field-label is-normal">
                    <label class="label">Details</label>
                </div>
                <div class="field is-expanded">
                    <p class="control has-icons-left">
                        <span class="select">
                           <select v-model="invoiceDetailsId">
                              <option :value="null" disabled>Select Invoice Details</option>
                              <option v-for="detail in invoiceDetails" :value="detail.value">{{ detail.text }}</option>
                           </select>
                        </span>
                        <span class="icon is-small is-left">
                           <i class="fas fa-globe"></i>
                        </span>
                    </p>
                </div>
            </div>
        </div>
</template>

<script>
    import apiRates from './../../../../api/apiRates'
    export default {
        computed: {
            rate: {
                get() {
                    return this.$store.getters.getCustomInvoice.rate
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceFieldValue', {field: 'rate', value: value })
                }
            },
            condition: {
                get() {
                    return this.$store.getters.getCustomInvoice.condition
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceFieldValue', {field: 'condition', value: value })
                }
            },
            incoterm: {
                get() {
                    return this.$store.getters.getCustomInvoice.incoterm
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceFieldValue', {field: 'incoterm', value: value })
                }
            },
            currency: {
                get() {
                    return this.$store.getters.getCustomInvoice.currency
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceFieldValue', {field: 'currency', value: value })
                }
            },
            invoiceDetailsId: {
                get() {
                    return this.$store.getters.getCustomInvoice.invoice_details_id
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceFieldValue', {field: 'invoice_details_id', value: value })
                }
            },
            client() {
                return this.$store.getters.getCustomInvoice.client
            },
            remarks: {
                get() {
                    return this.$store.getters.getCustomInvoice.remarks
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceFieldValue', {field: 'remarks', value: value })
                }
            },
            invoiceDetails() {
                return this.$store.getters.getCustomInvoiceContactDetails
            }
        },
        mounted () {
            apiRates
                .getAllRatesRequest()
                .then((response) => {
                    this.$store.dispatch('changeCustomInvoiceFieldValue', {field: 'rate', value: response.data[0].price })
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }
</script>

<style scoped>
    .field-label {
        flex-grow: 0;
    }
    .field-label .label {
        font-size: medium !important;
    }
    .remarks {
        width: 85%;
        max-width: 740px;
    }
    .label {
        white-space: nowrap;
        min-width: 100px;
    }
    .is-static {
        min-width: 50px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Invoices/CustomInvoice/CustomInvoiceSettings.vue